<template>
  <div class="convo-edit">
  <div class="w3-row-padding">
    <div class="w3-col m12">
    <div class="w3-card w3-round w3-white">
      <div class="w3-container w3-padding">
      <h6 class="w3-opacity" style="text-align:center">Start a Conversation</h6>
      <div class="w3-left-align">
        <input ref="title" v-focus="inputFocused" @focus="inputFocused = true" @blur="inputFocused = false" type="text" name="title" placeholder="TITLE" v-model="convoForm.title" class="form-control">
        <textarea-autosize ref="body" rows="3" placeholder="Start a conversation..." v-model="convoForm.body" class="form-control"></textarea-autosize>
        <!--
        <rich-text v-bind:content="convoForm.body" />
        -->

        <br/>

        <input @keyup.enter="addFormReference()" type="text" name="urlReference" placeholder="REFERENCE URL" v-model="convoForm.referenceUrl" class="w3-left w3-margin-right" style="width: 100%; margin-bottom: 5px">
        <br />
        <input @keyup.enter="addFormReference()" type="text" name="urlDesc" placeholder="REFERENCE DESCRIPTION" v-model="convoForm.referenceDesc" class="w3-margin-bottom" style="width: 100%">
        <br />
        <div v-for="(reference, index) in convoForm.references" :key="reference.id" class="w3-medium"> 
        <span v-if="reference.url" class="w3-left">{{reference.url}} &nbsp; </span>
        <span v-if="reference.description" class="w3-left">{{reference.description}} &nbsp; </span>
        <button @click="removeFormReference(index)" type="button" class="w3-button w3-text-theme" style="padding:0"><i class="far fa-times-circle"></i></button> 
        </div>
        <br />
        
        <input @keyup.enter="addFormTag()" type="text" name="tags" placeholder="TAG" v-model="convoForm.tag" class="w3-margin-bottom">
        <span v-for="(tag) in convoForm.tags" :key="tag.id" class="w3-tag w3-medium w3-theme-d5 w3-margin-right w3-margin-bottom"> 
        {{tag}} &nbsp;<a @click="removeFormTag(tag)" type="button" class="w3-theme-d5"> X</a>
        </span>
      </div>
      <div>
        <save-button @save="addConvo()" v-bind:type="'fal'" v-bind:icon="'comments'"/>
        &nbsp;
        <clear-button @clear="resetForm()"/>
      </div>
      </div>
    </div>
    </div>
  </div>
  <br />
  <div style='background-color: #c0e0e8; padding-top:5px; padding-bottom: 5px'>
    <div class="w3-container w3-white w3-round w3-margin" v-for="(statement) in convoForm.statements" :key="statement.id">
    <statement-view v-bind:statement="statement" v-bind:buttonType="'remove'" />
    </div>
  </div>

  <br />
  <div class="w3-container w3-card w3-white w3-round w3-margin-left w3-margin-bottom" v-for="(statement) in statements" :key="statement.id">
    <statement-view v-bind:statement="statement" v-bind:buttonType="'add'" />
  </div>
  </div>
</template>

<script>
  import ConvoEdit from './ConvoEdit.ts'
  export default ConvoEdit
</script>
